'use strict';

const { getDependencyClass } = require('../../lib/dependencies.js');
const { investmentCalculator } = require('./partials/investmentCalculator.js');

getDependencyClass('phoenix-page').then((pageClass) => {
    /**
     * PhoenixQuoteMediaCalculator is a web component
     * responsible for loading calculator on Quote Page
     *
     * @example
     *  <phoenix-quote-media-calculator>
     *  </phoenix-quote-media-calculator>
     */
    class PhoenixQuoteMediaCalculator extends pageClass.PhoenixElement {
        // web component life cycle hook
        connectedCallback() {
            super.connectedCallback();
            const calculatorConfig = {
                lang: 'en',
                amount: 10000,
                hideSymbolInput: false,
                modal: true,
                chart: {
                    enabled: true,
                    type: 'area',
                    height: '250',
                    color: '#026289',
                },
            };
            this._render(calculatorConfig);
        }

        _render(config) {
            let qmodConfig = JSON.stringify(config);
            this.innerHTML = `
                <div data-qmod-tool="investmentcalculator"
                    data-qmod-params=${qmodConfig}
                    class="qtool"
                >
                    <script type="text/template">
                        ${investmentCalculator()}
                    </script>
                </div>
            `;
        }
    }

    window.customElements.define('phoenix-quote-media-calculator', PhoenixQuoteMediaCalculator);
});
